import { GridSize } from 'owa-timestream-store';

// default minimum asset width
export const DEFAULT_MIN_ASSET_WIDTH = 224;

// legacy default minimum asset width
export const LEGACY_DEFAULT_MIN_ASSET_WIDTH = 232;

// spacing distance between newly created assets
export const ASSET_PADDING = GridSize;

// default width used to calculate x-positioning of newly created assets where height may not be defined.
export const ASSUMED_ASSET_WIDTH = DEFAULT_MIN_ASSET_WIDTH + ASSET_PADDING;

// size of the resize handle on resizable assets. Typically half the handle is exposed outside of the asset.
export const RESIZE_HANDLE_SIZE = 12; // derived from ResizeableElement.scss

// default top margin width
export const TOP_MARGIN = 16;

// default left margin width
export const LEFT_MARGIN = 16;

// default bottom margin width
export const BOTTOM_MARGIN = 64;

// grid size for asset positioning and alignment
export const GRID_SIZE = GridSize;
